export enum PlayerActionTypes {
  PLAY = '@@player/PLAY',
  PAUSE = '@@player/PAUSE',
  STOP = '@@player/STOP',
  TIME_UPDATE = '@@player/TIME_UPDATE',
}
